import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PromemoriaService } from 'src/app/core/promemoria.service';
import { SignalrService } from 'src/app/core/signalr.service';

@Component({
  selector: 'app-promemoria-badge',
  templateUrl: './promemoria-badge.component.html',
  styleUrl: './promemoria-badge.component.scss',
})
export class PromemoriaBadgeComponent implements OnInit, OnDestroy {
  totalePromemorie: number = 0;
  private subscription!: Subscription;

  constructor(
    private readonly promemoriaService: PromemoriaService,
    private readonly signalService: SignalrService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.promemoriaService.getPromemoria().subscribe({
      next: (lista) => {
        this.totalePromemorie = lista.length;
        // this.signalService.setInitialCount(lista.length);
      },
      error: (err) => console.error(err)
    });

    // this.subscription = this.signalService.remindersCount$.subscribe(count => {
    //   this.totalePromemorie = count;
    // });
  }

  navigaAPromemoria(): void {
    this.router.navigate(['/promemoria']);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
